<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal mainInputDiv">
    <form [formGroup]="copyProductForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              label="Product name"
              name="productName"
              placeholder="Product name"
              formControlName="productName"
              [control]="copyProductForm.controls['productName']"
              [submitted]="submitted"
              [maxLength]="50"
            ></piqet-angular-common-input>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="organizationList?.length && !productData.isCustomItem">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="form-group">
            <label class="labelColor">Organization</label>
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              [items]="organizationList"
              [searchable]="true"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="commonInputSearch"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback"><i class="fa fa-search icon"></i></span>
                </div>
              </ng-template>

              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
            </ng-select>

            <!-- Improved validation for organization -->
            <div
              *ngIf="
                (submitted || copyProductForm.get('organizationName')?.touched) &&
                copyProductForm.get('organizationName')?.hasError('required')
              "
              class="input-error"
            >
              Organization is required.
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer text-margin">
    <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
